class VideoComment extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }
  
    connectedCallback() {
      this.initSlider();
      this.setupVideoControls();
      console.log('VideoComment component initialized');
    }
  
    initSlider(){
      const container    = this.querySelector('.swiper-container');
      const paginationEl = this.querySelector('.swiper-pagination');
      const prevBtn      = this.querySelector('.swiper-button-prev');
      const nextBtn      = this.querySelector('.swiper-button-next');
  
      this.swiper = new Swiper(container, {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 18,
        threshold: 30,
        loop: true,
        centeredSlides: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
            989: {
                slidesPerView: 'auto',
                slidesOffsetAfter: 18,
                loop: false,
                centeredSlides: false,
            },
        },
      });

      this.swiperComment = new Swiper('.swiper-comment', {
        slidesPerView: 1.4,
        spaceBetween: 12,
        inialSlide: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        speed: 5000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, 
        },
        slidesOffsetBefore: 12,
        slidesOffsetAfter: 12,
        breakpoints: {
          500: {
            slidesPerView: 2.2,
          },
          989: {
            slidesPerView: 3.1,
            spaceBetween: 18, 
          },
          1200:{
            slidesPerView: 4.8,
            loop: true,
          }
        }
      });
    }
  
    setupVideoControls() {
        this.querySelectorAll(".video-comment__content").forEach((videoContainer) => {
            const video = videoContainer.querySelector("video");
            const stopButton = videoContainer.querySelector(".video-comment__button-stop");
            const playButton = videoContainer.querySelector(".video-comment__button-play");
            const soundButton = videoContainer.querySelector(".video-comment__button-sound");
            const img = videoContainer.querySelector("img");

            const soundOnIcon = soundButton.querySelector(".sound-on");
            const soundOffIcon = soundButton.querySelector(".sound-off");

            if (video) {
                video.controls = false;
            }

            if (stopButton) {
                stopButton.style.display = "none";
            }

            const toggleVideo = () => {
                if (video) {
                    if (video.paused) {
                        img.style.display = "none";
                        video.play().catch((err) => console.error("Erreur en jouant la vidéo:", err));
                        if (playButton) playButton.style.display = "none";
                        if (stopButton) stopButton.style.display = "flex";
                    } else {
                        video.pause();
                        if (playButton) playButton.style.display = "flex";
                        if (stopButton) stopButton.style.display = "none";
                    }
                }
            };

            if (img) img.addEventListener("click", toggleVideo);
            if (video) video.addEventListener("click", toggleVideo);
            if (playButton) playButton.addEventListener("click", toggleVideo);
            playButton.addEventListener("click", () => {
                console.log('on a cliquer sur le playButton');
            });
            if (stopButton) stopButton.addEventListener("click", toggleVideo);

            if (soundButton) {
                soundButton.addEventListener("click", () => {
                    if (video) {
                        video.muted = !video.muted;
                        soundOnIcon.style.display = video.muted ? "none" : "flex";
                        soundOffIcon.style.display = video.muted ? "flex" : "none";
                    }
                });
            }
        });
    }
  }
  
  customElements.define('video-comment', VideoComment);
  